var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.177 0.0825195H3.37818C2.62235 0.0825195 1.89747 0.397516 1.36302 0.958213C0.828572 1.51891 0.52832 2.27938 0.52832 3.07232V21.0111C0.52832 21.8041 0.828572 22.5646 1.36302 23.1253C1.89747 23.686 2.62235 24.0009 3.37818 24.0009H26.177C26.9328 24.0009 27.6577 23.686 28.1922 23.1253C28.7266 22.5646 29.0269 21.8041 29.0269 21.0111V3.07232C29.0269 2.27938 28.7266 1.51891 28.1922 0.958213C27.6577 0.397516 26.9328 0.0825195 26.177 0.0825195ZM26.177 7.10856L14.7776 15.0824L3.37818 7.10856V3.51631L14.7776 11.4886L26.177 3.51631V7.10856Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.758ccf49206da22049f4812457458e40.svg";
export { ForwardRef as ReactComponent };